import { loadModules, loadCss, setDefaultOptions } from 'esri-loader'

const ARCGIS_VERSION = '4.26'
const options = { version: ARCGIS_VERSION }

setDefaultOptions(options)

export const loadAllModules = (modules) => {
  return new Promise((resolve, reject) => {
    loadModules(modules)
      .then((results) => {
        const regex = /[^/]*$/
        const allModulesObject = {}
        modules.forEach((module, i) => {
          allModulesObject[module.match(regex)] = results[i]
        })
        resolve(allModulesObject)
      })
      .catch((error) => reject(error))
  })
}

export const loadEsriCss = () => {
  loadCss(ARCGIS_VERSION)
}
